import React from 'react';
import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { childNodes } from 'Helpers/PropTypes';
import HouseholdSectionLegacy from './HouseholdSectionLegacy';
import HouseholdSection from './HouseholdSection/HouseholdSection';


const HouseholdSectionPicker = ({ resource, label, children }) => {
  return pick(resource, {
    [fr.relationships.householdSectionMember.name]: (
      <HouseholdSection label={label}>{children}</HouseholdSection>
    ),
  }, (
    <HouseholdSectionLegacy label={label}>{children}</HouseholdSectionLegacy>
  ));
};

HouseholdSectionPicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
  label: PropTypes.string.isRequired,
  children: childNodes.isRequired,
};
HouseholdSectionPicker.defaultProps = {};

export default HouseholdSectionPicker;
